import React, { useContext, useState } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Button,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";

import Ironman from "../Assets/Ironman.png";
import Mjolnir from "../Assets/Mjolnir.png";
import Wanda from "../Assets/Wanda.png";
import WandaMagic2 from "../Assets/WandaMagic2.png";

import { SocialIcon } from "react-social-icons";

import { AppContext } from "./Context.js";

import emailjs from "emailjs-com";
import Cookies from "universal-cookie";

import "../CSS/ContactMe.css";

export default function AboutMe({ id }) {
  const [itemSnapped] = useContext(AppContext);

  const [contactInfo, setContactInfo] = useState({
    userName: "",
    message: "",
    userEmail: "",
  });
  const cookies = new Cookies();
  const [sendMsg, setSendMsg] = useState(false);
  const [msgStatus, setMsgStatus] = useState(false);
  const [failed, setFailed] = useState(false);
  const [errors, setErrors] = useState(false);

  const handleClose = () => {
    setSendMsg(false);
  };

  function sendEmail() {
    console.log(contactInfo);
    setSendMsg(true);
    if (
      contactInfo.userName === "" ||
      contactInfo.userEmail === "" ||
      contactInfo.message === ""
    ) {
      setErrors(true);
    } else {
      setErrors(false);
      emailjs
        .send(
          "service_7nih1cc",
          "template_oeht76r",
          contactInfo,
          "user_5VNqxip2MvNyAv8pV8h4i"
        )
        .then(
          (result) => {
            //console.log(result.text);
            setMsgStatus(true);
            cookies.set("U83", "1T2R3U4E", { maxAge: 86000 });
          },
          (error) => {
            //console.log(error.text);
            setFailed(true);
          }
        );
    }
  }
  return (
    <React.Fragment>
      <div
        id={id}
        className={itemSnapped === "ContactMe" ? "vanish" : "contactMe"}
      >
        <Grid container spacing={0} className="bgCM">
          <Grid item md={12} sm={12} xs={12}>
            <div className="titleDiv">
              <h1 className="sectionsTitle">ContactMe</h1>
            </div>
          </Grid>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            style={{ paddingLeft: "10vw", paddingRight: "10vw" }}
          >
            <span className="descr">
              Feel free to contact me if you wanna work together or maybe play
              some online games
            </span>
            <span>😁</span>
            <span className="descr">
              You can contact me through my social media below or by sending a
              message here.
            </span>
          </Grid>

          <Grid item md={12} sm={12} xs={12} style={{ marginBottom: "15px" }}>
            <SocialIcon
              className="socialIcons"
              url="https://github.com/MohamedWSalah"
              fgColor="white"
              bgColor="#d10100"
              target="_blank"
            />
            <SocialIcon
              className="socialIcons"
              url="https://www.linkedin.com/in/mohamedwsalah/"
              fgColor="white"
              bgColor="#d10100"
              target="_blank"
            />
            <SocialIcon
              url="https://discordapp.com/users/209487951577481216"
              fgColor="white"
              className="socialIcons"
              bgColor="#d10100"
              target="_blank"
            />
            <SocialIcon
              url="mailto:mohamedwsalah@outlook.com"
              fgColor="white"
              bgColor="#d10100"
              className="socialIcons"
              target="_blank"
            />
          </Grid>

          <Grid container spacing={3}>
            <Grid item md={12} sm={12} xs={12}>
              <FormControl className="formControl">
                <InputLabel
                  className="inputLabel"
                  startadornment={
                    <InputAdornment position="start">
                      <img
                        src={Ironman}
                        alt=""
                        style={{ height: 35, width: 35 }}
                      />
                    </InputAdornment>
                  }
                >
                  Your Name?
                </InputLabel>
                <Input
                  onChange={(e) => {
                    setContactInfo({
                      ...contactInfo,
                      userName: e.target.value,
                    });
                  }}
                  multiline
                  startAdornment={
                    <InputAdornment position="start">
                      <img
                        src={Ironman}
                        alt=""
                        style={{ height: 35, width: 35 }}
                      />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <FormControl className="formControl">
                <InputLabel className="inputLabel">Your E-mail?</InputLabel>
                <Input
                  onChange={(e) => {
                    setContactInfo({
                      ...contactInfo,
                      userEmail: e.target.value,
                    });
                  }}
                  multiline
                  startAdornment={
                    <InputAdornment position="start">
                      <img
                        src={Mjolnir}
                        alt=""
                        style={{ height: 35, width: 35 }}
                      />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <FormControl className="formControl">
                <InputLabel className="inputLabel">Message</InputLabel>
                <Input
                  onChange={(e) => {
                    setContactInfo({
                      ...contactInfo,
                      message: e.target.value,
                    });
                  }}
                  multiline
                  startAdornment={
                    <InputAdornment position="start">
                      <img
                        src={Wanda}
                        alt=""
                        style={{ height: 35, width: 35 }}
                      />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Button className="sendMsgBtn" onClick={() => sendEmail()}>
                Send Message
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {sendMsg ? (
          <Backdrop
            style={{
              zIndex: "0",
              color: "#fff",
              position: "absolute",
              transition: " all 0.5s ease",
              backgroundImage: `url(${WandaMagic2})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            open={sendMsg}
            onClick={handleClose}
          >
            {errors ? (
              <p className="backdropText">complete the fields please?</p>
            ) : msgStatus ? (
              cookies.get("U83") ? (
                <p className="backdropText">
                  Chill, You already sent a message, Try again later
                </p>
              ) : (
                <p className="backdropText">sent</p>
              )
            ) : failed ? (
              <p className="backdropText">Failed, Probably server error</p>
            ) : (
              <CircularProgress color="inherit" />
            )}
          </Backdrop>
        ) : null}
      </div>
    </React.Fragment>
  );
}
